export default "__VITE_ASSET__CqstmTxp__"